import * as React from 'react';
import Divider from 'material-ui/Divider';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';

import { Toggle, ToggleField, RemoteAutoCompleteField, RemoteAutoComplete, DateField, Date } from '@components/form';

const View: React.SFC<any> = ({ noticeOfficer }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={6} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Botička</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ToggleField
                component={Toggle}
                name="clampPayed"
                label="Nasazená"
                labelPosition="right"
                disabled={true}
              />
            </Col>
          </Row>
        </Col>
        <Col md={6} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>{noticeOfficer ? 'Vyrozumění' : 'Odtah'}</h4>
            </Col>
          </Row>
          <Row>
            {noticeOfficer ? (
              <>
                <Col md={12}>
                  <RemoteAutoCompleteField
                    component={RemoteAutoComplete}
                    id="noticeOfficer"
                    name="noticeOfficer"
                    label="Vyrozumění"
                    url="/metropolis/api/hr/employees"
                    labelFunction={o => get(o, 'fullName')}
                    disabled={true}
                    fullWidth={true}
                  />
                </Col>

                <Col md={12}>
                  <DateField
                    component={Date}
                    name={'noticeDate'}
                    label={'Datum a čas vyrozumění'}
                    dateOnly={false}
                    disabled={true}
                  />
                </Col>
              </>
            ) : (
              <Col md={12}>
                <ToggleField
                  component={Toggle}
                  name="towPayed"
                  label="Provedeno"
                  disabled={true}
                  labelPosition="right"
                />
              </Col>
            )}
          </Row>
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const DelictsFormClamp = View;



// WEBPACK FOOTER //
// ./src/modules/delicts/DelictsFormClamp.tsx